import { BUSD_BSC, USDC_BSC, USDT_BSC, WBNB_BSC } from "../useQueryPrices";

const RATES_BASE_TOKENS: Record<number, string[]> = {
  56: [WBNB_BSC, USDT_BSC, USDC_BSC, BUSD_BSC],
};

export { RATES_BASE_TOKENS };
